import React from 'react';

import SavedDraftsTable from '../../procurement_plan/SavedDraftsTable';
import PurchaseOrdersIndex from '../../purchase_orders/PurchaseOrdersIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementPurchaseOrdersTab = () => {
    const { settings, routes } = useProcurement();

    return (
        <>
            {/* A held draft is the first step of an EA/DC, so its Saved Drafts list lives here —
                above Pending — as the single source of truth, not on the Plan tab (IB-610 #2). */}
            <SavedDraftsTable draftsIndexUrl={routes.draftsIndexUrl} deleteDraftUrl={routes.deleteDraftUrl} />
            <PurchaseOrdersIndex
                approvalPOStatuses={settings.approvalPOStatuses}
                pendingPOStatus={settings.pendingPOStatus}
                indexPOUrl={routes.fetchPurchaseOrderUrl}
                updatePOUrl={routes.updatePurchaseOrderUrl}
                deletePOUrl={routes.deletePurchaseOrderUrl}
                cancelPOUrl={routes.cancelPurchaseOrderUrl}
                togglePOUrl={routes.togglePurchaseOrderUrl}
                indexPOUrlApproved={routes.fetchApprovedPurchaseOrdersUrl}
                indexPOUrlRejected={routes.fetchRejectedPurchaseOrdersUrl}
                indexPOUrlCanceled={routes.fetchCanceledPurchaseOrdersUrl}
            />
        </>
    );
};

export default ProcurementPurchaseOrdersTab;
